import React from 'react';
import Layout from '../components/Layout';

export default function Disclaimer() {
  return (
    <Layout>
      <div className="page-banner">
        <h1>Disclaimer</h1>
      </div>
      <div className="main-content">
        <div className="policy-content">
          <h2>Disclaimer</h2>
          <p className="updated">Last Updated: May 21, 2026</p>

          <p>
            The content on Smart Device Assistant is for informational purposes only. While we strive for accuracy,
            we make no guarantees about the completeness or reliability of the information.
          </p>

          <ul>
            <li>
              <strong>No Professional Advice:</strong> This website is not a substitute for manufacturer instructions,
              technical support, or professional advice.
            </li>
            <li>
              <strong>External Links:</strong> We may link to third-party websites. We do not control and are not
              responsible for the content or practices of these external sites.
            </li>
            <li>
              <strong>Personal Information Submitted:</strong> Any information you provide through contact forms or
              chat features is collected and used in accordance with our Privacy Policy.
            </li>
            <li>
              <strong>Ads Disclosure:</strong> Our site uses Google Ads and other advertising networks. Ads may be
              personalized based on your browsing activity.
            </li>
            <li>
              <strong>Limitation of Liability:</strong> Smart Device Assistant is not liable for any direct or
              indirect damages resulting from your use of our website, chat, contact forms, or external links.
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  );
}
